import { Injectable, Input, inject } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import { Breadcrumb } from './Breadcrumb';
import { TranslocoLocaleService } from '@jsverse/transloco-locale';

@Injectable({
	providedIn: 'root',
})
export class BreadCrumbService {
	translocoService = inject(TranslocoService);
	translocoLocaleService = inject(TranslocoLocaleService);

	@Input() private _crumbs: Breadcrumb[] = [];

	get crumbs(): any[] {
		return this._crumbs;
	}

	addBreadCrumb(value: Breadcrumb) {
		const keys: string[] = [];
		for (const crumb of this._crumbs) {
			keys.push(crumb.translationKey);
		}
		if (keys.indexOf(value.translationKey) === -1) {
			this._crumbs.push(value);
		} else {
			for (const crumb of this._crumbs) {
				if (crumb.translationKey === value.translationKey) {
					crumb.additionalInfo = value.additionalInfo;
				}
			}
		}
	}

	slice(start: number, end: number) {
		return (this._crumbs = this._crumbs.slice(start, end));
	}

	reset(): void {
		this._crumbs = [];
	}
}
